import styled from "styled-components";

import { BaseButton } from "@shared/styles/common.styled";

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const CompletedButton = styled(BaseButton)`
  background: #368939;
  border: 1px solid #368939;
  font-weight: normal;
`;

export const InProgressButton = styled(BaseButton)`
  background: #ff5101;
  border: 1px solid #ff5101;
  font-weight: normal;
`;

export const DraftButton = styled(BaseButton)`
  background: #1bace4;
  border: 1px solid #1bace4;
  font-weight: normal;
`;
